import querystring from 'query-string';
import { raygun } from '@ynap/clientside-monitoring';

// Format yyyyMMddHHmmss eg: 20171014090000
export const getCoreMediaForwardDate = (date) => date.toISOString().replace(/-|T|:/g, '').slice(0, -5);

// Format "CCYY-MM-DD HH:mm:SS" eg: "2017-10-14 09:00:00"
export const getWCSPreviewDate = (date) => date.toISOString().replace('T', ' ').slice(0, -5);

export const buildQueryParams = (params) => (Object.keys(params).length > 0 ? `?${querystring.stringify(params)}` : '');

export const buildAffiliateBodyProperties = ({ sessionOnly } = { sessionOnly: false }) => {
    const properties = {};

    if (!document?.cookie) {
        return properties;
    }

    const partnerizeMatches = document.cookie.match(/pz_clickref=([^;]*)/i);
    const sessionMatches = document.cookie.match(/tp_session=([^;]*)/i);
    if (partnerizeMatches?.length > 0 || sessionMatches?.length > 0) {
        properties.x_TPSession = partnerizeMatches?.[1] || sessionMatches?.[1];
        if (properties.x_TPSession.length > 49) {
            // https://jira.nap/browse/AIM-2678
            // Some affiliate urls being generated with invalid url params, if too long for WCS to handle trim to 6.
            raygun.helpers.agent('send', {
                error: 'Invalid affiliate affiliate cookie',
                tags: ['affiliates', 'x_TPSession'],
                customData: { x_TPSession: properties.x_TPSession },
            });
            properties.x_TPSession = properties.x_TPSession.slice(0, 49);
        }
    }

    const historicMatches = document.cookie.match(/tp_historic=([^;]+)/i);
    if (!sessionOnly && historicMatches?.length > 0) {
        properties.x_TPHistoric = historicMatches[1];
        if (properties.x_TPHistoric.length > 49) {
            // https://jira.nap/browse/AIM-2678
            // Some affiliate urls being generated with invalid url params, if too long for WCS to handle trim to 6.
            raygun.helpers.agent('send', {
                error: 'Invalid affiliate affiliate cookie',
                tags: ['affiliates', 'x_TPHistoric'],
                customData: { x_TPHistoric: properties.x_TPHistoric },
            });
            properties.x_TPHistoric = historicMatches[1].slice(0, 49);
        }
    }

    return properties;
};

export const buildAffiliateContextAttribute = () => {
    const { x_TPSession } = buildAffiliateBodyProperties({ sessionOnly: true });

    return x_TPSession
        ? [
              {
                  attributeName: 'maTrackingPartnerCode',
                  attributeValue: {
                      value: x_TPSession,
                  },
              },
          ]
        : [];
};

export const nativeAppHeaders = (isNativeApp) => {
    return isNativeApp
        ? {
              'X-Native-App': 'true',
          }
        : {};
};
